import { render, staticRenderFns } from "./TheSourceCollapse.vue?vue&type=template&id=2383d9d9&scoped=true&"
import script from "./TheSourceCollapse.vue?vue&type=script&lang=js&"
export * from "./TheSourceCollapse.vue?vue&type=script&lang=js&"
import style0 from "./TheSourceCollapse.vue?vue&type=style&index=0&id=2383d9d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2383d9d9",
  null
  
)

export default component.exports